module.exports = __webpack_public_path__ + "static/media/Asset 43.a2e769bf.png";